module.exports = __webpack_public_path__ + "img/icon_map_ddsh_c.44feb076.png";